







import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class ReportsPageHeaderComponent extends Vue {
  @Prop({ required: true })
  public title!: string;

  @Prop({ default: '' })
  public subtitle!: string;
}
